import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import ViewReverse from '../../components/ViewReverse';
import ViewItems from '../../components/ViewItems';
import { Dropdown } from '../../components';
import CustomInput from '../../components/CustomInput';
import Button from '../../components/Button';
import CustomDatePicker from '../../components/CustomDatePicker';
import { rowReverseStylemd, rowReverseStylesm } from '../../utils/styles';
import CustomModal from '../../components/CustomModal';
import transferFunctional from './index.function';
import { Formik } from 'formik';
import { transfer_schema, transfer_validation_schema } from '../../validations_schemas/transfer_validation_schema';
import ErrorText from '../../components/ErrorText';
import { getAccountBalance } from '../../store/actions/transferAction';
import { transaction_schema, transaction_validation_schema } from '../../validations_schemas/transaction_validation_schemas';
import OtpModal from '../../components/OtpModal';
import { number_regix } from '../../utils/functions';
import { cn, formatNumbers } from '../../utils/utils';
import SarSymbol from '../../components/SarSymbol';
import dayjs from 'dayjs';
import { TransferView } from './components';
import Divider from '../../components/Divider';

const Transfer = () => {
  const {
    isArabic,
    TextWeight,
    direction,
    isShowModal,
    transactionList,
    transferData,
    transferInfo,
    availableBalance,
    transactionLoading,
    dispatch,
    getContentKey,
    onSearchTransactions,
    onSubmitTransfer,
    toogleModal,
    navigate,
    otpModal,
    toogleOtpModal,
    onVerify,
    onReviewSubcription,
    transferLoading,
    totalAmount,
    fee_withdrawal,
    clientDetails,
  } = transferFunctional();

  return (
    <div>
      <Text text={getContentKey('heading')} weight={TextWeight.bold} size={fontSizes.h18} />

      <Formik
        validationSchema={transfer_validation_schema}
        initialValues={transfer_schema}
        onSubmit={(values, functions) => onSubmitTransfer(values, functions?.resetForm)}
        validateOnChange={false}
        validateOnMount={false}
      >
        {({ handleSubmit, setFieldValue, setFieldError, values, resetForm, errors }) => {
          const isValid =
            availableBalance > 0 &&
            values?.to &&
            values?.amount &&
            Number(values?.amount) <= Number(availableBalance) && transferInfo?.reasonList?.length > 0
          // &&
          // (values?.reason?.id?.toString() === '1454' ? values?.other_reason?.trim()?.length > 1 : true);

          return (
            <ViewItems className={'border border-grey mt-2 rounded-lg shadow px-5 py-3'}>
              <ViewReverse className={'w-full gap-4 sm:gap-6 flex-wrap'}>
                {transferInfo && (
                  <ViewItems>
                    <Text text={getContentKey('available_balance')} color='text-primary-light' size={fontSizes.h14} />
                    <Text
                      text={`${formatNumbers(availableBalance)}`}
                      size={fontSizes.h26}
                      weight={TextWeight.medium}
                      leftSymbol
                    />
                  </ViewItems>
                )}
              </ViewReverse>

              <ViewReverse className={`w-full gap-2 sm:gap-6 mt-4 flex-col ${rowReverseStylesm(isArabic)}`}>
                <ViewItems className={'w-full'}>
                  <Dropdown
                    label={getContentKey('to_account')}
                    options={transferInfo?.toAccountList ? transferInfo?.toAccountList : []}
                    selectedValue={values?.to}
                    valueKey={'name'}
                    isRequired
                    onSelect={(val) => {
                      setFieldValue('to', val);
                      setFieldError('to', null);
                    }}
                    isError={errors?.to}
                  />
                  {errors?.to && <ErrorText text={getContentKey(errors?.to)} />}

                  <Text
                    text={isArabic ? ' + ' + getContentKey('add_beneficiary') : getContentKey('add_beneficiary') + ' + '}
                    color='text-primary'
                    size={fontSizes.h14}
                    className={cn('mt-2 cursor-pointer underline', isArabic ? 'self-start' : 'self-end')}
                    onClick={() => navigate('/transfers/beneficiaries')}
                  />
                </ViewItems>

                <div className='w-full'>
                  {values?.to?.currency && (
                    <>
                      <Text text={getContentKey('currency')} color='text-primary-light' size={fontSizes.h14} />

                      {
                        values?.to?.currency === "SAR" ?
                          <SarSymbol size={fontSizes.h20} className={'mt-2'} />
                          :
                          <Text text={values?.to?.currency} size={fontSizes.h20} className={'mt-2'} />
                      }
                    </>
                  )}
                </div>
              </ViewReverse>
              {/* )} */}

              <ViewItems className={'mt-3'}>
                <Text text={getContentKey('currency')} color='text-primary' size={fontSizes.h14} />
                <SarSymbol size={fontSizes.h26} className={'mt-2'} />
              </ViewItems>
              <ViewReverse className={cn('w-full mt-4 gap-2 sm:gap-6 flex-col', rowReverseStylesm(isArabic))}>
                <ViewItems className={'w-full'}>
                  <CustomInput
                    label={getContentKey('amount')}
                    placeholder={'0'}
                    value={values?.amount}
                    onChange={(e) => {
                      const isNumber = number_regix.test(e.target.value);

                      if (isNumber) {
                        setFieldValue('amount', e.target.value);
                        if (Number(e.target.value) > availableBalance) {
                          setFieldError('amount', 'greater_amount_validation');
                        } else {
                          setFieldError('amount', null);
                        }
                      }
                    }}
                    isRequired
                    isRounded
                    type='number'
                    isError={errors?.amount}
                    isDisabled={!availableBalance || availableBalance <= 0}
                  />
                  <ErrorText text={getContentKey(errors?.amount)} />
                </ViewItems>
                <div className='w-full hidden sm:block'></div>
              </ViewReverse>

              {/* <ViewReverse className={'w-full gap-4 mt-4'}>
                <CustomRadio
                  label={getContentKey('same_day_transfer')}
                  value={true}
                  groupValue={values?.is_same_day}
                  onClick={() => setFieldValue('is_same_day', true)}
                />
                <CustomRadio
                  label={getContentKey('next_day_transfer')}
                  value={false}
                  groupValue={values?.is_same_day}
                  onClick={() => setFieldValue('is_same_day', false)}
                />
              </ViewReverse> */}
              <ViewReverse className={`gap-6 w-full mt-5`}>
                <ViewItems>
                  <Text text={getContentKey('remaining_balance')} color='text-primary' size={fontSizes.h14} />
                  <Text
                    text={formatNumbers(Number(availableBalance ?? 0) - Number(values?.amount)) ?? 0}
                    size={fontSizes.h20}
                    className={'mt-1.5'}
                    leftSymbol
                  />
                </ViewItems>
              </ViewReverse>
              <ViewReverse className={cn('my-4 w-full gap-2 sm:gap-6 flex-col', rowReverseStylesm(isArabic))}>
                <ViewItems className={'w-full'}>
                  {/* <Dropdown
                    label={getContentKey('reason')}
                    options={transferInfo?.reasonList ? transferInfo?.reasonList : []}
                    selectedValue={values?.reason}
                    valueKey={'name'}
                    onSelect={(val) => {
                      setFieldError('reason', null);
                      setFieldValue('reason', val);
                      setFieldValue('other_reason', '');
                    }}
                    isError={errors?.reason}
                  />
                  {errors?.reason && <ErrorText text={errors?.reason} getContentKey={getContentKey} />} */}
                  <CustomInput
                    label={getContentKey('reason')}
                    value={transferInfo?.reasonList?.[0]?.name}
                    isRounded
                    isDisabled
                  />
                </ViewItems>

                {/* <CustomInput
                  label={getContentKey('other_reason')}
                  placeholder={getContentKey('add_info')}
                  value={values?.other_reason}
                  onChange={(e) => setFieldValue('other_reason', e.target.value)}
                  isRounded
                  isError={errors?.other_reason}
                  isDisabled={values?.reason?.id?.toString() !== '1454'}
                /> */}
                <div className='w-full hidden sm:block' />
              </ViewReverse>

              <Divider margin='my-0 mt-2' />

              <ViewReverse className='items-center gap-2 mt-4 mb-6'>
                <Button
                  text={getContentKey('transfer_btn')}
                  bgColor='bg-primary'
                  className={'uppercase w-36 px-0 text-center'}
                  isDisabled={!isValid}
                  loading={transferLoading}
                  onClick={handleSubmit}
                />
                <Button
                  text={getContentKey('clear_btn')}
                  color={'text-primary'}
                  bgColor='bg-white'
                  className={'uppercase border border-primary w-36 px-0 text-center'}
                  onClick={() => {
                    dispatch(getAccountBalance());
                    resetForm();
                  }}
                />
              </ViewReverse>
            </ViewItems>
          );
        }}
      </Formik>

      <Formik
        validationSchema={transaction_validation_schema}
        initialValues={transaction_schema}
        onSubmit={(values, functions) => onSearchTransactions(values, functions?.resetForm)}
        validateOnChange={false}
        validateOnMount={false}
      >
        {({ handleSubmit, setFieldValue, setFieldError, values, resetForm, errors }) => {
          return (
            <ViewItems className={'border border-grey rounded-lg p-5 mt-6'}>
              <ViewReverse className={cn('w-full flex-col gap-2 justify-between', rowReverseStylemd(isArabic))}>
                <Text text={getContentKey('transaction_date')} size={fontSizes.h18} weight={TextWeight.bold} />
                <ViewReverse className={'gap-2'}>
                  <Button
                    text={getContentKey('search')}
                    bgColor='bg-primary'
                    className={'uppercase w-32 px-0 text-center border border-orange'}
                    onClick={handleSubmit}
                    loading={transactionLoading}
                    type={'button'}
                  />
                  <Button
                    text={getContentKey('clear_btn')}
                    color={'text-primary'}
                    bgColor='bg-white'
                    className={'uppercase border border-primary w-32 px-0 text-center'}
                    onClick={() => {
                      resetForm();
                    }}
                  />
                </ViewReverse>
              </ViewReverse>

              <ViewReverse className={cn('gap-4 flex-col mt-4 w-full items-start', rowReverseStylemd(isArabic))}>
                <ViewItems className={'w-full'}>
                  <CustomDatePicker
                    label={getContentKey('from_date')}
                    onChange={(date) => setFieldValue('from_date', date?.$d)}
                    width='w-full'
                    isError={errors?.from_date}
                    isRequired
                    placeholder={getContentKey('from_date')}
                    selectedDate={values?.from_date}
                    maxDate={dayjs()}
                  />
                  <ErrorText text={getContentKey(errors?.from_date)} />
                </ViewItems>
                <ViewItems className={'w-full'}>
                  <CustomDatePicker
                    label={getContentKey('to_date')}
                    onChange={(date) => setFieldValue('to_date', date?.$d)}
                    width='w-full'
                    isError={errors?.to_date}
                    placeholder={getContentKey('to_date')}
                    isRequired
                    selectedDate={values?.to_date}
                    maxDate={dayjs()}
                  />
                  <ErrorText text={getContentKey(errors?.to_date)} />
                </ViewItems>
              </ViewReverse>
              {transactionList?.length > 0 ? (
                <div dir={direction} className='grid grid-cols-1 md:grid-cols-2 gap-4 w-full mt-4 items-start'>
                  {transactionList?.map((item, index) => (
                    <TransferView item={item} getContent={getContentKey} key={index} />
                  ))}
                </div>
              ) : (
                !transactionLoading &&
                <Text
                  text={getContentKey('no_withdrawals_found')}
                  size={fontSizes.h16}
                  isCenter
                  className={'mt-10'}
                />
              )}
            </ViewItems>
          );
        }}
      </Formik>

      <CustomModal isOpen={isShowModal} heading={getContentKey('heading')} isFullWidth onClose={toogleModal}>
        <Text text={getContentKey('transfer_summary')} color='text-text-grey/60' size={fontSizes.h14} />

        {/* <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('type')} color='text-primary-light' size={fontSizes.h14} />
          <Text text={'Local'} size={fontSizes.h14} />
        </ViewReverse> */}
        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('to')} color='text-primary-light' size={fontSizes.h14} />
          <Text text={transferData?.code} size={fontSizes.h14} />
        </ViewReverse>
        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('amount')} color='text-primary-light' size={fontSizes.h14} />
          <ViewReverse isReverse={false}>
            <SarSymbol />
            <Text text={formatNumbers(transferData?.amount)} size={fontSizes.h14} />
          </ViewReverse>
        </ViewReverse>
        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('currency')} color='text-primary-light' size={fontSizes.h14} />
          <SarSymbol />
        </ViewReverse>
        {/* {
          fee_withdrawal?.transferMode?.length > 0 &&
          <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
            <Text text={getContentKey('transfer_mode')} size={fontSizes.h14} color='text-primary-light' />
            <ViewReverse>
              <Text
                text={fee_withdrawal?.transferMode}
                size={fontSizes.h14}
              />
            </ViewReverse>
          </ViewReverse>
        } */}
        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('transfer_fee')} color='text-primary-light' size={fontSizes.h14} />
          <ViewReverse isReverse={false}>
            <SarSymbol />
            <Text text={fee_withdrawal?.transferFee} size={fontSizes.h14} dir={"lrt"} />
          </ViewReverse>
        </ViewReverse>
        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('total_amount')} color='text-primary-light' size={fontSizes.h14} />
          <ViewReverse isReverse={false}>
            <SarSymbol />
            <Text text={formatNumbers(totalAmount)} size={fontSizes.h14} dir={"lrt"} />
          </ViewReverse>
        </ViewReverse>
        {/* <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('date')} color='text-primary-light' size={fontSizes.h14} />
          <Text text={new Date().toLocaleDateString()} size={fontSizes.h14} />
        </ViewReverse> */}

        {/* <ViewReverse className="justify-between border-b py-2 border-b-grey">
          <Text
            text={''}
            color="text-primary-light"
            size={fontSizes.h14}
          />
          <Text text={transferData?.isSameDay ? getContentKey('same_day_transfer') : getContentKey('next_day_transfer')} size={fontSizes.h14} />
        </ViewReverse> */}
        <ViewReverse className='items-center w-full justify-end gap-2 mt-3'>
          <Button
            text={getContentKey('edit')}
            color={'text-dark-grey'}
            bgColor='bg-white'
            className={'border border-dark-grey w-32 px-0 text-center border-opacity-50'}
            onClick={toogleModal}
          />
          <Button
            text={getContentKey('transfer_btn')}
            bgColor='bg-primary'
            className={'w-32 px-0 text-center border border-orange'}
            onClick={onReviewSubcription}
            loading={transferLoading}
          />
        </ViewReverse>
      </CustomModal>

      <OtpModal open={otpModal} type={4} onClose={() => toogleOtpModal()} onVerify={onVerify} clientDetails={clientDetails}
        transferData={transferData} />
    </div>
  );
};

export default Transfer;
